<template>
  <div id="blog-edit">
    <v-divider></v-divider>

    <!-- Edit Form -->
    <form
      name="richTextBlogItemForm"
      v-if="tab === 'edit'"
      @submit.prevent="updateBlogItem">
      <div class="row align-center">
        <!-- Title -->
        <div class="col">
          <v-text-field
            hide-details
            label="Title"
            placeholder=" "
            v-model="blogItem.title">
          </v-text-field>
        </div>
        <!-- / Title -->

        <!-- Date -->
        <div class="col-auto">
          <DatePicker
            input-id="blog-date"
            v-model="blogItem.date"
            label="Date"
            :line-bottom="true"
          />
        </div>
        <!-- / Date -->

        <!-- Hidden -->
        <div
          class="hidden-checkbox col-auto">
          <v-checkbox
            height="28"
            label="Hidden"
            v-model="blogHidden">
          </v-checkbox>
        </div>
        <!-- / Hidden -->
      </div>

      <div class="row">
        <div class="col">
          <label class="d-block mb-1">Image:</label>
          <ImageInput
            v-model="blogItem.imageContent"
            :clearable="true"
          />
        </div>
      </div>

      <v-divider></v-divider>

      <WYSIWYG
        class="page-tab-content-expand"
        v-model="blogItem.content">
      </WYSIWYG>

      <div class="page-buttons d-flex my-5">
        <v-btn
          type="submit"
          color="primary">
          Save
        </v-btn>

        <v-btn
          @click="goToBlogList"
          type="button"
          color="primary"
          class="mr-auto order-first"
          outlined>
          Cancel
        </v-btn>
      </div>
    </form>
    <!-- / Edit Form -->

    <!-- Revisions -->
    <BlogRevisions
      v-if="tab === 'revisions'"
    />
    <!-- / Revisions -->
  </div>
</template>

<script>
import WYSIWYG from './WYSIWYG/WYSIWYG.vue';
import DatePicker from './DatePicker.vue';
import ImageInput from './ImageInput.vue';
import BlogItemMixin from '../mixin.blog-item';
import BlogRevisions from './BlogRevisions.vue';

export default {
  name: 'BlogEditForm',
  props: ['tab'],
  mixins: [
    BlogItemMixin,
  ],
  components: {
    WYSIWYG,
    DatePicker,
    ImageInput,
    BlogRevisions,
  },
};
</script>

<style lang="scss">
#blog-edit {
  form[name="richTextBlogItemForm"] {
    max-width: 900px;

    .hidden-checkbox {
      .v-input__slot {
        margin: 0;
      }
    }
  }
}
</style>
